<template>
  <!---环境数据详情---->
  <div class="container">
    <crumb prevLevel="生产数据监管/环境数据" :current="currentTitle" />
    <div class="search">
      <el-form label-width="120px">
        <el-row>
          <el-col :span="9">
            <el-form-item label="时间范围">
              <el-date-picker
                v-model="stockTime"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd HH:mm:ss"
                class="stockTime"
              />
            </el-form-item>
          </el-col>
          <el-col :span="3" class="styleTop">
            <el-form-item label-width="0">
              <el-button type="primary" style="margin-left:30px" @click="init"
                >查询</el-button
              >
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="statistic">
      <div class="title">温度记录</div>
      <div class="charts-container">
        <Echarts
          :echartsOption="echartsOption1"
          :echartsWidth="echartsWidth"
          echartsHeight="400px"
          v-if="echartsWidth"
        />
      </div>
    </div>
    <div class="statistic">
      <div class="title">湿度记录</div>
      <div class="charts-container">
        <Echarts
          :echartsOption="echartsOption2"
          echartsHeight="400px"
          :echartsWidth="echartsWidth"
          v-if="echartsWidth"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Echarts from 'components/echarts/echarts';
import Crumb from 'components/crumb/crumb';

export default {
  data() {
    return {
      stockTime: '',
      currentTitle: '',
      echartsWidth: '',
      echartsOption1: {
        title: {
          text: '',
          subtext: ''
        },
        grid: {
          bottom: 0,
          left: 100,
          right: 30,
          containLabel: true
        },
        dataZoom: {
          type: 'inside',
          show: true,
          realtime: true
        },
        tooltip: {
          formatter: params => {
            return (
              '<p>' +
              params.marker +
              params.name +
              '</p>' +
              '<p style="text-align: center">' +
              params.value +
              '℃</p>'
            );
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          axisTick: {
            show: false,
            alignWithLabel: true
          },
          axisLabel: {
            textStyle: {
              color: '#666'
            },
            rotate: '30'
          },
          axisLine: {
            lineStyle: {
              color: 'rgba(206,219,239,0.5)'
            }
          },
          data: []
        },
        yAxis: {
          name: '℃',
          nameTextStyle: {
            color: '#000'
          },
          color: '#000',
          type: 'value',
          axisLabel: {
            textStyle: {
              color: '#999'
            }
          },
          axisPointer: {
            snap: true
          },
          splitLine: {
            lineStyle: {
              color: 'rgba(206,219,239,0.5)'
            }
          },
          axisLine: {
            lineStyle: {
              color: 'rgba(206,219,239,0.5)'
            }
          }
        },
        series: [
          {
            name: '',
            type: 'line',
            lineStyle: {
              color: '#386CE2'
            },
            itemStyle: {
              color: ({ data }) => {
                if (data.isUnnormal) {
                  return 'red';
                } else {
                  return '#386CE2';
                }
              },
              borderWidth: 2
            },
            data: [],
            symbol: 'circle',
            symbolSize: 8
          }
        ]
      },
      echartsOption2: {
        title: {
          text: '',
          subtext: ''
        },
        grid: {
          bottom: 0,
          left: 100,
          right: 30,
          containLabel: true
        },
        dataZoom: {
          type: 'inside',
          show: true,
          realtime: true,
          startValue: 0,
          endValue: 20
        },
        tooltip: {
          formatter: params => {
            return (
              '<p>' +
              params.marker +
              params.name +
              '</p>' +
              '<p style="text-align: center">' +
              params.value +
              '%</p>'
            );
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          axisTick: {
            show: false,
            alignWithLabel: true
          },
          axisLabel: {
            textStyle: {
              color: '#666'
            },
            rotate: '30'
          },
          axisLine: {
            lineStyle: {
              color: 'rgba(206,219,239,0.5)'
            }
          },
          data: []
        },
        yAxis: {
          name: '%',
          nameTextStyle: {
            color: '#000'
          },
          color: '#000',
          type: 'value',
          axisLabel: {
            textStyle: {
              color: '#999'
            }
          },
          axisPointer: {
            snap: true
          },
          splitLine: {
            lineStyle: {
              color: 'rgba(206,219,239,0.5)'
            }
          },
          axisLine: {
            lineStyle: {
              color: 'rgba(206,219,239,0.5)'
            }
          }
        },
        series: [
          {
            name: '',
            type: 'line',
            symbolSize: 8,
            lineStyle: {
              color: '#386CE2'
            },
            itemStyle: {
              color: ({ data }) => {
                if (data.isUnnormal) {
                  return 'red';
                } else {
                  return '#386CE2';
                }
              },
              borderWidth: 2
            },
            data: [],
            symbol: 'circle'
          }
        ]
      }
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      const {
        entName,
        entType,
        storeHouseType,
        storeHouseName,
        storeHouseAddress
      } = this.$route.query;
      this.currentTitle = `${storeHouseType}-${storeHouseName}`;
      const timeRange = this.stockTime
        ? new Date(this.stockTime[1]).getTime() -
          new Date(this.stockTime[0]).getTime()
        : '';
      const paramsData = {
        genTimeEnd: '',
        genTimeStart: '',
        handlerName: 'STORE_TEMP_HANDLER',
        storeHouseAddress,
        storeHouseName,
        storeHouseType,
        entName,
        entType
      };
      if (!timeRange) {
        paramsData.numLimit = '20';
        paramsData.genTimeEnd = '';
        paramsData.genTimeStart = '';
      } else if (timeRange > 86400000) {
        this.$alert('非常抱歉，由于数据量过大，只支持24小时内查询');
        return;
      } else {
        paramsData.genTimeEnd = this.stockTime[1];
        paramsData.genTimeStart = this.stockTime[0];
      }
      this.echartsWidth = '';
      this.$request({
        url: 'rest/statistic/reportData',
        data: {
          json: JSON.stringify({
            pageBean: {
              pageNum: 1,
              pageSize: 10000
            },
            params: paramsData
          })
        }
      }).then(res => {
        const xData = [];
        const y1Data = [];
        const y2Data = [];
        // const listLen = res.list[0].temperature.length;
        // const echartsWidth = listLen * 40;
        // this.echartsWidth = echartsWidth > 1352 ? echartsWidth + 'px' : '100%';
        this.echartsWidth = '100%';

        res.list[0].temperature.forEach((item, index) => {
          xData.push(item.gen_time);
          y1Data.push({
            value: item.temp_value,
            isUnnormal: item.exception_type === '1'
          });

          y2Data.push({
            value: item.humidity_value,
            isUnnormal: item.exception_type === '2'
          });
        });
        this.echartsOption1.xAxis.data = xData;
        this.echartsOption1.series[0].data = y1Data;
        this.echartsOption2.xAxis.data = xData;
        this.echartsOption2.series[0].data = y2Data;
      });
    }
  },
  components: {
    Echarts,
    Crumb
  }
};
</script>

<style lang="stylus" scoped>
.stockTime
  width 100% !important
.container
  width 1352px
  background #fff
  border-radius 4px
  margin-left -46px
  color #000
  padding 0 20px
  .search
    padding 30px 0
  .statistic
    padding 0 0 50px 0
    .title
      font-size 14px
      color #242424
      line-height 40px
      border-bottom 1px solid rgba(206,219,239,0.5)
      padding-left 44px
      font-weight 700
  .charts-container
    overflow-x auto
</style>
